import { defineComponent as _defineComponent } from 'vue'
import type { ContentPickerSourceMenuListItem } from '@@/bits/content_picker'
import { ContentPickerSource } from '@@/bits/content_picker'
import device from '@@/bits/device'
import { __ } from '@@/bits/intl'
import type { SearchFilters } from '@@/bits/web_search'
import ChicletButton from '@@/vuecomponents/ChicletButton.vue'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ContentPickerSourceMenuList',
  props: {
    menuList: null,
    clipboardText: null,
    xClipboardButton: { type: Boolean },
    isPhoneScreen: { type: Boolean },
    isDisabledOnDrag: { type: Boolean, default: false }
  },
  emits: ["paste-text", "focus-search-bar", "select-default", "select", "trigger-link-input", "trigger-ai-image-search"],
  setup(__props: any, { emit }: { emit: ({
  (name: 'paste-text'): void
  (name: 'focus-search-bar', payload: SearchFilters): void
  (name: 'select-default', payload: string): void
  (name: 'select', payload: ContentPickerSource): void
  (name: 'trigger-link-input'): void
  (name: 'trigger-ai-image-search'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { menuList: Array<Array<ContentPickerSourceMenuListItem>>, clipboardText: string, xClipboardButton: boolean, isPhoneScreen: boolean, isDisabledOnDrag: boolean };





const displayedSourceMenuLists = computed<Array<Array<ContentPickerSourceMenuListItem>>>(() => {
  const visibleItemLists = props.menuList
    .map((list) => list.filter((item) => item.visible))
    .filter((list) => list.length > 0)
  const displayedLists: Array<Array<ContentPickerSourceMenuListItem>> = []

  // If 2 adjacent lists have less than or equal to 3 items, we group them together
  let i = 0
  let bucket: ContentPickerSourceMenuListItem[] = []
  while (i < visibleItemLists.length) {
    bucket.push(...visibleItemLists[i])
    if (bucket.length >= 3) {
      displayedLists.push(bucket)
      bucket = []
    }
    i++
  }
  if (bucket.length > 0) displayedLists.push(bucket)

  // If total items count is less than or equal to 9, we group all lists together
  const itemsCount = displayedLists.reduce((count, list) => count + list.length, 0)
  return itemsCount <= 9 ? [displayedLists.flat()] : displayedLists
})

// Triggers <input file> element and use camera directly
const triggerNativeInputWithCamera = (id: string): void => {
  const input = document.getElementById(id)
  if (input) {
    input.setAttribute('capture', 'environment')
    input.click()
    input.removeAttribute('capture')
  }
}

const onClick = (item: ContentPickerSourceMenuListItem) => {
  if (item.hiddenInputId) {
    if (
      device.mobile &&
      item.type !== ContentPickerSource.FileBrowser // For file browser, don't open camera
    ) {
      triggerNativeInputWithCamera(item.hiddenInputId)
    } else {
      document.getElementById(item.hiddenInputId)?.click()
    }
  }

  emit(item.actionType as any, item.actionPayload as any)
}

return { __sfc: true,props, emit, displayedSourceMenuLists, triggerNativeInputWithCamera, onClick, __, ChicletButton }
}

})